export const GET_STUDENTS_REQUEST = 'GET_STUDENTS_REQUEST';
export const GET_STUDENTS_SUCCESS = 'GET_STUDENTS_SUCCESS';
export const GET_STUDENTS_FAILURE = 'GET_STUDENTS_FAILURE';

export const getStudentsByUserId = (productId, userProfileId) =>
    ({ type: GET_STUDENTS_REQUEST, productId, userProfileId, isLoadingEditStudentDetail: true });

export const getStudentsSuccess = ({ data }) =>
    ({ type: GET_STUDENTS_SUCCESS, data, isLoadingEditStudentDetail: false });

export const getStudentsFailure = () =>
    ({ type: GET_STUDENTS_FAILURE, isLoadingEditStudentDetail: false });

export const OPEN_UNASSIGN_STUDENTS_MODAL = 'OPEN_UNASSIGN_STUDENTS_MODAL';
export const CLOSE_UNASSIGN_STUDENTS_MODAL_CONFIRMATION = 'CLOSE_UNASSIGN_STUDENTS_MODAL_CONFIRMATION';

export const openUnAssignStudentsModal = () =>
    ({ type: OPEN_UNASSIGN_STUDENTS_MODAL, isUnassignedModalOpen: true });

export const closeUnAssignStudentsModalConfirmation = () =>
    ({ type: CLOSE_UNASSIGN_STUDENTS_MODAL_CONFIRMATION, refreshStudentsAfterUnAssign: false });

export const UNASSIGN_STUDENTS_USING_CLASSID_REQUEST = 'UNASSIGN_STUDENTS_USING_CLASSID_REQUEST';
export const UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS = 'UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS';
export const UNASSIGN_STUDENTS_USING_CLASSID_FAILURE = 'UNASSIGN_STUDENTS_USING_CLASSID_FAILURE';

export const unassignStudentsUsingClassId = (userProfileId, classId) =>
    ({ type: UNASSIGN_STUDENTS_USING_CLASSID_REQUEST, userProfileId, isUnassignedModalOpen: true, classId, unassignDisableButton: true });

export const unassignStudentsByClassIdSuccess = () =>
    ({ type: UNASSIGN_STUDENTS_USING_CLASSID_SUCCESS, isUnassignedModalOpen: false, unassignDisableButton: false });

export const unassignStudentsByClassIdFailure = () =>
    ({ type: UNASSIGN_STUDENTS_USING_CLASSID_FAILURE, unassignDisableButton: false });


export const EDIT_STUDENT_REQUEST = 'EDIT_STUDENT_REQUEST';
export const EDIT_STUDENT_SUCCESS_REQUEST = 'EDIT_STUDENT_SUCCESS_REQUEST';
export const EDIT_STUDENT_FAILURE_REQUEST = 'EDIT_STUDENT_FAILURE_REQUEST';

export function editStudent(student, updatingStudent, context) {
    return {
        type: EDIT_STUDENT_REQUEST,
        student,
        updatingStudent,
        context
    };
}

export function editStudentSuccess(context) {
    context.router.history.push('/students');
    return {
        type: EDIT_STUDENT_SUCCESS_REQUEST,
        updatingStudent: false
    };
}

export function editStudentFailure(isServerError, editStudentValidationMessage, showEditStudentValidationModal = true) {
    return {
        type: EDIT_STUDENT_FAILURE_REQUEST,
        editStudentValidationMessage,
        showEditStudentValidationModal,
        updatingStudent: false,
        isServerError
    };
}

export const CLOSE_EDIT_STUDENT_VALIDATION_MODAL = 'CLOSE_EDIT_STUDENT_VALIDATION_MODAL';

export function closeEditStudentValidationModal() {
    return {
        type: CLOSE_EDIT_STUDENT_VALIDATION_MODAL,
        showEditStudentValidationModal: false
    };
}

export const REFRESH_STUDENT_LIST_ON_CANCEL_REQUEST = 'REFRESH_STUDENT_LIST_ON_CANCEL_REQUEST';

export function refreshStudentListOnCancel() {
    return { type: REFRESH_STUDENT_LIST_ON_CANCEL_REQUEST, refreshStudentList: true };
}

export const SHOW_HIDE_MODAL = 'SHOW_HIDE_MODAL';

export function showHideModal(status) {
    return { type: SHOW_HIDE_MODAL, showModal: status };
}



// WEBPACK FOOTER //
// ./app/containers/edit-student/actions.js